import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-432d8480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { class: "navlogo" }
const _hoisted_3 = { class: "navlogoimg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-menu" }, null, -1))
const _hoisted_5 = {
  class: "a",
  href: "/about"
}
const _hoisted_6 = {
  class: "a",
  href: "/tech"
}
const _hoisted_7 = {
  class: "a",
  href: "/https://mp.weixin.qq.com/s/Lr99oR4oKxfTt5JntUjIyw?poc_token=HN0AxGajCDftDRILJVc1bC2YTS4pHDD_UvM1RYFH"
}
const _hoisted_8 = {
  class: "a",
  href: "/talent"
}
const _hoisted_9 = {
  class: "a",
  href: "/recruit"
}
const _hoisted_10 = {
  class: "a",
  href: "/contact"
}
const _hoisted_11 = {
  class: "a",
  target: "_blank",
  href: "https://rekeymed.com/ram/admin/"
}
const _hoisted_12 = {
  class: "a",
  href: "/about"
}
const _hoisted_13 = {
  class: "a",
  href: "/about#devhistory"
}
const _hoisted_14 = {
  class: "a",
  href: "/about#comhonor"
}
const _hoisted_15 = {
  class: "a",
  href: "/about#culture"
}
const _hoisted_16 = {
  class: "a",
  target: "_blank",
  href: "https://www.zhipin.com/gongsi/116b4325cefd01781XF_2N-4GVM~.html?from=top-card"
}
const _hoisted_17 = {
  class: "a",
  target: "_blank",
  href: "https://rekeymed.com/ram/admin/"
}
const _hoisted_18 = { class: "select" }

import { onBeforeUnmount, onMounted, ref, watch, watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import {getProductNav} from '@/api/product'
import {useNav} from './useNav'

export default /*#__PURE__*/_defineComponent({
  __name: 'NavView',
  setup(__props) {

const {
  SelectSubItem,
  handleSelect,
  activeIndex,
  isCollapse,
  ellipsis,
  navWidth,
  locale,
  changeLang,
  changeHref,
  langs,
  productNav
  
} = useNav()
const router = useRouter()
// const langs = [
//   { show: '中', locale: 'zh-CN' },
//   { show: 'en', locale: 'en' }
// ]

// const isCollapse = ref(false)
// const ellipsis = ref(false)
// const navWidth = ref(window.innerWidth) // 导航栏的宽度，初始值为当前屏幕宽度
// const activeIndex = ref('/')
// const productNav = ref([])

// // const handleSelect = (key: string, keyPath: string[]) => {
// //   console.log(key,keyPath);
  
// //   sessionStorage.setItem('activeIndex', key)
// //   router.push(key)

// // }
// // const SelectSubItem = (item) => {
// //   console.log(item)

// // }
// const locale = ref(sessionStorage.getItem('locale') || 'zh-CN')
// const changeLang = (e) => {
//   console.log(e)
//   const currentUrl = window.location.href
//   // 通过改变 URL 参数来触发页面刷新
//   window.location.href = currentUrl
//   sessionStorage.setItem('locale', e)
// }
// const changeHref = (e) => {
//   sessionStorage.setItem('activeIndex', e)
// }
// // 添加窗口大小变化时的监听器，实时更新导航栏宽度
// const updateNavWidth = () => {
//   navWidth.value = window.innerWidth
//   isCollapse.value = window.innerWidth < 800
//   ellipsis.value = window.innerWidth < 1250

// }

// // 添加窗口大小变化时的监听器，实时更新折叠状态
// const updateCollapse = () => {
//   navWidth.value = window.innerWidth
//   isCollapse.value = window.innerWidth < 800
//   ellipsis.value = window.innerWidth < 1250
// }
// // 添加窗口大小变化时的监听器，实时更新导航栏宽度
// window.addEventListener('resize', updateNavWidth)
// onMounted(() => {
//   getProductNav().then(res => {
//     productNav.value = res.data
//   })
//   // 在组件挂载时调用方法
//   activeIndex.value = sessionStorage.getItem('activeIndex') || '/'
//   locale.value = sessionStorage.getItem('locale') || 'zh-CN'
//   // 添加窗口大小变化时的监听器，实时更新折叠状态
//   window.addEventListener('resize', updateCollapse)
//   // 更新导航栏宽度
//   updateNavWidth()
// })

// onBeforeUnmount(() => {
//   // 组件销毁前，移除监听器
//   window.removeEventListener('resize', updateCollapse)
// })

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "nav",
          style: _normalizeStyle({ width: _unref(navWidth) + 'px' })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
              [_directive_lazy, require('@/assets/LOGO.png')]
            ])
          ]),
          _createVNode(_component_el_menu, {
            "text-color": "#545251",
            "active-text-color": "#3270ad",
            "default-active": _unref(activeIndex),
            class: "el-menu-demo",
            mode: "horizontal",
            onSelect: _unref(handleSelect),
            ellipsis: _unref(ellipsis)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Home Page')), 1)
                ]),
                _: 1
              }),
              (_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 0,
                    index: "more"
                  }, {
                    title: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(_toDisplayString(_ctx.$t('More')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/about" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('About')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/productdetails" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Product Center')) + " ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/tech" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('Innovative Technology')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/news" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('News information')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/talent" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('talentDev')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/recruit" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('rekeyRecruit')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/contact" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('Contact us')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/service" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('ServiceCenter')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('RAM System')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 1,
                    index: "/about"
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "a",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(changeHref)('/about'))),
                        href: "/about"
                      }, _toDisplayString(_ctx.$t('About us')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/about" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('Company Profile')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/about#devhistory" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('Development History')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/about#comhonor" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t('Company Honor')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/about/rdteam" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('R&D Team')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/about#culture" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t('Company Culture')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 2,
                    index: "/product"
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Product Center')), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productNav), (item) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          onClick: ($event: any) => (_unref(SelectSubItem)(item)),
                          index: '/product/'+item.nav_index,
                          key: item.nav_index,
                          to: "/productdetails"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "index"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 3,
                    index: "/tech"
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Innovative Technology')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/tech" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('TechPlatform')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 4,
                    index: "news"
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('News information')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/companynews" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Company News')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/industrynews" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Industry News')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 5,
                    index: "contact"
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Contact us')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/talent" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('talentDev')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('rekeyRecruit')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/contact",
                        to: "/contact"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Contact')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 6,
                    index: "/service"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('ServiceCenter')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isCollapse))
                ? (_openBlock(), _createBlock(_component_el_menu_item, { key: 7 }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t('RAM System')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.$i18n.locale,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
                  onChange: _unref(changeLang)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langs), (lang, i) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: lang.show,
                        key: `Lang${i}`,
                        value: lang.locale
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ]),
            _: 1
          }, 8, ["default-active", "onSelect", "ellipsis"])
        ], 4)
      ]),
      _: 1
    })
  ]))
}
}

})